<template>
  <div 
    class="card" 
    @mouseenter="hoverId = item.codigo"
    @mouseleave="hoverId = null"
    :style="{
      width: '200px'
    }"
  >
    <div
      ref="current-speaker"
      class="speaker-img"
      :style="{
        '--zoom-size': `${settings.layout.zoom || '125'}%`,
        '--border-speaker': `${settings.layout.color1 || '#000000'}`,
        backgroundImage: `url('${item.url_avatar}')`,
      }"    
    ></div>
    <div class="d-flex flex-column flex pt-4 px-4" >
      <div 
        class="title-container"
        :style="{
          '--border-title': `${settings.layout.color1 || '#000000'}`,
        }"        
      >
        <span 
          class="titleCard" 
          :style="{
            color: settings.layout['text-color1'] || '#24252D', 
            fontSize: item.nome.length > 15 ? '14px': '18px'
          }"
        >
        {{item.nome}}
        </span>
      </div>

      <v-tooltip bottom max-width="220" :disabled="!infoTooltip" :color="settings.layout['tooltip-color']">
        <template v-slot:activator="{ on }">
          <span 
            v-on="on"
            ref="info-speaker"
            class="subtitleCard" 
            :style="{
              color: settings.layout['text-color2'] || '#666D80'
            }"
          >
            {{ getSpeakerInfo }}
          </span>
        </template>
        <div :style="{'font-size': '0.8rem'}">
          <span class="d-block pb-2">
            <b :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF', 'font-weight': '900'}">
              {{ item.cargo }}
            </b>
          </span>

          <span class="d-block" :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF'}">
            {{ item.empresa }}
          </span>
        </div>
      </v-tooltip>

      <div 
        :class="['linkedin text-center pt-2']"
        :style="{
          opacity: item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo) ? '1' : '0'
        }"
      >
        <v-btn fab color="transparent" class="elevation-0" x-small @click.stop="$emit('onClickLinkedin', item)">
          <v-icon color="bt_color" size="24">fa-brands fa-linkedin</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["item", "settings"],
  computed: {
    getBoxShadow () {
      const shadow = this.settings.layout.shadow
      const distance = this.settings.layout.distance
      if (shadow) return `${distance}px ${distance}px 0 1px ${shadow}`
      else return 'none'
    },

    getSpeakerInfo () {
      if (this.settings.layout.companyPosition) return `${this.item.cargo} - ${this.item.empresa}`
      else return this.item.empresa
    }    
  },

  data: () => ({
    hoverId: null,
    infoTooltip: false
  }),

  watch: {
    hoverId (id) {
      const currentSpeaker = this.$refs['current-speaker']
      if (id === this.item.codigo) {
        currentSpeaker.style.backgroundSize = `auto var(--zoom-size) !important`
        const infoSpeaker = this.$refs['info-speaker']
        const isInfoSpeakerEllipsed = infoSpeaker.scrollHeight > infoSpeaker.clientHeight
        this.infoTooltip = isInfoSpeakerEllipsed
      } else {
        currentSpeaker.style.backgroundSize = `auto 100%`
        this.infoTooltip = false
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 200px;
  max-width: 200px;
  transition: all 1s;
  padding-bottom: 12px;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.speaker-img {
  position: relative;
  transition: all 0.5s;
  border-radius: 50%;
  width: 200px;
  height: 200px;
  background-position: center;
  background-size: auto 100%;
}

.speaker-img::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;  
  border: 4px solid var(--border-speaker) !important;
  border-radius: 50%;
  z-index: 1; 
}

.speaker-img:hover {
  cursor: pointer;
  background-size: auto var(--zoom-size) !important;
}

span {
  display: block;
}

.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 38px;
  border: 2px solid !important;
  border-color: var(--border-title) !important;
  border-radius: 20px;
  padding: 0 12px 0 12px;
  margin-bottom: 12px;
}

.titleCard {
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: center;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%;  
}

.subtitleCard {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
  line-height: 18px;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 100%;
  color: #666D80
}

.linkedin {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: start;
  transition: opacity 0.3s ease-in-out, visibility 0s linear 0.3s;
}
</style>
